<template>
	<div class="deviceparam" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }" v-if="link.length>0">
		<div style="text-align:center;">
		 <span style="padding-right:10px;">{{deviceparam_lang.pname}}</span>	<el-input type="text" v-model="p_name" size="mini" style="width:280px;margin-top:10px;"></el-input>
		</div>
		<div class="card-content" :style="{ height: `${windowHeight - 110}px` , 'overflow-y': 'auto' }">
			<div class="item" v-for="(item, index) in link" :key="index">
				<div class="second-item">
					<div class="second-header">
						<span>{{ item.p_sys }}</span>
					</div>
					<div class="second-body">
						<div class="second-item" v-for="(i, secondIndex) in item.sonlink" :key="secondIndex">
							<span class="second-cbx">{{ i.paramname }}</span>
							<div class="lastBox">
								<el-row class="row">
									<el-col :span="10" v-if="i.issel=='1'">
										<div v-if="i.paramwhere!=''">
											<el-tag
											  v-for="(tag,t) in JSON.parse(i.paramwhere)"
											  :key="tag.p_no"
											  closable style="margin-left:5px;margin-top:5px" @close="removetag(t,i)">
											  {{tag.p_sort}}
											</el-tag>
											<div v-if="JSON.parse(i.paramwhere).length==0">
												<el-tag style="color: #fff;background-color:#00aaff">{{deviceparam_lang.all}}</el-tag>
											</div>
										</div>
										<div v-else>
											<el-tag style="color: #fff;background-color:#00aaff">{{deviceparam_lang.all}}</el-tag>
										</div>
										<el-button style="margin-top:10px;margin-bottom:5px;" type="warning" size="mini" 
										:plain="btnplain" @click="selectcargosort(i,secondIndex,index)">{{deviceparam_lang.setcargosort}}</el-button>
										<el-button v-if="i.paramwhere!=''" style="margin-top:10px;margin-bottom:5px;margin-left:5px;" type="danger" size="mini"
										:plain="btnplain" @click="i.paramwhere=''">{{deviceparam_lang.reset}}</el-button>
										
									</el-col>
									<el-col :span="10" v-else-if="i.issel=='2'">
										<div v-if="i.paramwhere!=''">
											<el-tag
											  v-for="(tag,t) in JSON.parse(i.paramwhere)"
											  :key="tag.cno"
											  closable style="margin-left:5px;margin-top:5px" @close="removetag(t,i)">
											  {{tag.cno}}
											</el-tag>
											<div v-if="JSON.parse(i.paramwhere).length==0">
												<el-tag style="color: #fff;background-color:#00aaff">{{deviceparam_lang.all}}</el-tag>
											</div>
										</div>
										<div v-else>
											<el-tag style="color: #fff;background-color:#00aaff">{{deviceparam_lang.all}}</el-tag>
										</div>
										<el-button style="margin-top:10px;margin-bottom:5px;" type="warning" size="mini" 
										:plain="btnplain" @click="selectcargo(i,secondIndex,index)">{{deviceparam_lang.setcargo}}</el-button>
										<el-button v-if="i.paramwhere!=''" style="margin-top:10px;margin-bottom:5px;margin-left:5px;" type="danger" size="mini"
										:plain="btnplain" @click="i.paramwhere=''">{{deviceparam_lang.reset}}</el-button>
									</el-col>
									<el-col :span="10" v-else>
										<span style="color: transparent;">1</span>
									</el-col>
									<el-col :span="5">
										<el-switch v-model="i.issync" active-color="#13ce66" active-value="1" inactive-value="0"></el-switch>
										{{deviceparam_lang.opensync}}
									</el-col>
									<el-col :span="5">
										<el-switch v-model="i.isclose" active-color="#13ce66" active-value="1" inactive-value="0" 
										@change="setclosetime(i)"></el-switch>
										{{deviceparam_lang.syncclosed}}
									</el-col>
								</el-row>
							</div>
						</div>
					</div>
				</div>
			</div>
			<el-row style="margin-top:10px">
				<el-col :span="2" style="text-align:right;padding-right:10px;">
					<span>{{deviceparam_lang.selecteddesk}}</span>
				</el-col>
				<el-col :span="17">
					<el-select 
					  v-model="desklist" size="mini"
					   multiple
					   filterable
					   :clearable="true"
					   style="width:50%">
							<el-option v-for="item in alldesklist" :key="item.deskid" :label="item.deskid" :value="item.deskid"></el-option>
					 </el-select>
				</el-col>
			</el-row>
		</div>
		<div class="footerdiv2">
			<el-row class="footerhandler" v-if="isshow">
				<el-col :span="6" style="color:transparent;">1</el-col>
				<el-col :span="4" class="submitBtn"><div @click="SaveParam">{{$lang.label.public.savebtn}}</div></el-col>
				<el-col :span="4" class="submitBtn_cancel"><div @click="cancel">{{$lang.label.public.cancel}}</div></el-col>
			</el-row>
		</div>
		<selectsort ref="selectsort" @checkedsortcallback="checkedsortcallback"></selectsort>
		<dialogwin ref="dialogwin" @dialogsrue="dialogsrue"></dialogwin>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import selectsort from '@/components/baseinfo/selectsort.vue';	
import dialogwin from '@/components/tools/dialogwin.vue';
export default {
	components: {
		selectsort,
		dialogwin
	},
	props: {
		urlparam: {
			type: Object,
			default:function(){
				return {};
			}
		},
		item: {
			type: Object,
			default:function(){
				return {
					
				};
			}
		}
	},
	data() {
		return {
			btnplain: true,
			windowHeight: window.innerHeight - 100,
			link: [],
			divclass:'deviceparam',
			p_name:'',
			desklist:[],
			deviceparam_lang:{},
			alldesklist:[],
			isshow:true,
			sonindex:-1,
			index:-1
		};
	},
	mounted() {
		import('../../static/' + this.$theme + '/style/baseinfo/deviceparam.scss');
		this.init();
	},
	methods: {
		//获取参数设置方案
		init() {
			//debugger
			this.loadlanguage();
			var that = this;
			if (this.urlparam != undefined) {
				if(this.urlparam.pkval!=undefined)
					this.p_name=this.urlparam.pkval;
			}
			this.getalldesklist();
		},
		loadlanguage(){
			var that=this;
			this.$public.GetLanguageByMode('deviceparam',this).then(res=>{
				if(res.state=='1')
				{
					that.deviceparam_lang=that.$lang.label.deviceparam;
					that.showwin=true;
				}
			});
		},
		getalldesklist(){
			var that=this;
			var paraminfo={
				token:localStorage.getItem('token'),
				domain:this.$apiprototype.WebServer
			};
			this.$apipost.get.GetDeskList({paraminfo:paraminfo}).then(res => {
				if (res != '') {
					//console.log('list',res.list);
					if(res.list!=undefined)
						that.alldesklist=res.list;
					that.GetParamtodevice();
				}
			});
		},
		GetParamtodevice(){
			var that=this;
			var paraminfo={
				p_name:this.p_name,
				token:localStorage.getItem('token'),
				domain:this.$apiprototype.WebServer
			};
			this.$tool.loading('正在加载', this.divclass);
			this.$apipost.get.GetParamtodevice({paraminfo:paraminfo}).then(res => {
				//debugger
				this.$tool.loadingclose();
				if (res != '') {
					//console.log('list',res.list);
					if(res.list!=undefined)
						that.link=res.list;
					if(res.desklist!=undefined){
						that.desklist = res.desklist;
					}	
				}
			});
		},
		//指定商品分类
		selectcargosort(i,sonindex,index){
			var that=this;
			//debugger
			this.$nextTick(function(){
				that.$refs.selectsort.init({searchjson:i.paramwhere,
				sonindex:sonindex,index:index});
			});
		},
		selectcargo(i,sonindex,index){
			var that=this;
			this.sonindex=sonindex;
			this.index=index;
			this.$apipost.get.GetLinkInfo({ l_id:576 }).then(res => {
				//debugger
				if (res.info != undefined) {
					var paramitem=res.info;
					paramitem.iswin=true;
					that.$refs.dialogwin.init({item:paramitem,title:this.deviceparam_lang.setcargo});
				} else that.$tool.message('此功能无法启用', 0);
			});
		},
		dialogsrue(e){
			//debugger
			var that = this;
			var rows = [];
			if(e.l_id==576){
				if(e.rows!=undefined)
				{
					if(e.rows.length>0){
						var conslist=[];
						if(that.link[that.index].sonlink[that.sonindex].paramwhere!=''){
							conslist=JSON.parse(that.link[that.index].sonlink[that.sonindex].paramwhere);
							rows=conslist;
						}
						//判断是否与已添加的商品重复，有重复的则不显示了
						//debugger
						e.rows.forEach(s=>{
							var isexists=false;
							conslist.forEach(c=>{
								if(c.pkcno==s.pkcno)
								{
									isexists=true;
									return false;
								}
							});
							if(!isexists)
								rows.push({cno:s.cno,pkcno:s.pkcno});
						});
					}
					//that.sourcelist[that.currentindex].cargolist=that.sourcelist[that.currentindex].cargolist.concat(rows);
					if(rows.length>0){
						that.link[that.index].sonlink[that.sonindex].paramwhere=JSON.stringify(rows);
					}
				}
			}
		},
		removetag(idx,i){
			var paramwhere=JSON.parse(i.paramwhere);
			paramwhere.splice(idx,1);
			if(paramwhere.length>0)
				i.paramwhere=JSON.stringify(paramwhere);
			else
				i.paramwhere='';
		},
		//同步后关闭参数设置
		setclosetime(i){
			//debugger
			if(i.isclose=='1')
				i.updatetime='1900-01-01';
			else
				i.updatetime=this.$tool.getcurrenttime();
		},
		checkedsortcallback(e){
			//debugger
			if(e.param!=undefined){
				var paramwhere=this.link[e.param.index].sonlink[e.param.sonindex].paramwhere;
				var list=[];
				if(paramwhere!=undefined&&paramwhere!='')
					list=JSON.parse(paramwhere);
				var iscount=list.filter(function(c){
					return c.p_no==e.p_no;
				});	
				
				if(e.type){//开启
					if(iscount==0)
						list.push({p_no:e.p_no,p_sort:e.p_sort});
				}else{//取消
					for(var i=0;i<list.length;i++){
						if(list[i].p_no==e.p_no){
							list.splice(i,1);
							break;
						}
					}
				}
				this.link[e.param.index].sonlink[e.param.sonindex].paramwhere=JSON.stringify(list);
			}
		},
		//保存参数
		SaveParam(){
			//debugger
			var that=this;
			var list=[];
			if(this.p_name==''){
				this.$tool.message(that.deviceparam_lang.pnameisempty, 0);
				return false;
			}
			if(this.desklist.length==0){
				this.$tool.message(that.deviceparam_lang.desklistisempty, 0);
				return false;
			}
			this.desklist.forEach(d=>{
					that.link.forEach(e=>{
						e.sonlink.forEach(b=>{
							var obj=JSON.parse(JSON.stringify(b));
							obj.p_name=that.p_name;
							obj.deskid=d;
							delete obj.isclose;
							delete obj.id;
							delete obj.parent_sys;
							delete obj.issel;
							list.push(obj);
						});
					});
			});
			if(list.length>0){
				var paraminfo={
					list:list,
					token:localStorage.getItem('token'),
					domain:this.$apiprototype.WebServer
				}
				this.$tool.loading(this.$lang.label.public.saving,'deviceparam');
				this.$apipost.post.SaveParamtodevice({paraminfo:paraminfo}).then(res => {
					if (res != '') {
						if(res.state=='1')
						{
							this.$tool.message(that.$lang.label.public.savesuccess,1);
							that.cancel();
						}	
						else
						{
							if(res.message!=undefined)
								this.$tool.message(res.message, 0);
							else
								this.$tool.message(that.$lang.label.public.savefail, 0);
							if(res.batch!=undefined){
								that.$tool.CreateErrorFile(that,res.batch);
							}
						}	
					}
				});
			}
		},
		cancel(){
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		}
	}
};
</script>
